// extracted by mini-css-extract-plugin
export default {"navigate":"Navigation_navigate__7O+WK"};